<template>
  <section v-if="users" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Invitations &amp; digest</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">Invitation funnel and weekly-digest subscription rate.</p>

    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Invitations sent</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ invitations.sent }}</p>
      </div>
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Accepted</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ invitations.accepted }}</p>
      </div>
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Acceptance rate</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ invitations.acceptance_rate }}%</p>
      </div>
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Avg. time to accept</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">
          {{ invitations.avg_days_to_accept === null ? '—' : invitations.avg_days_to_accept }}
          <span v-if="invitations.avg_days_to_accept !== null" class="text-sm font-normal text-gray-400">days</span>
        </p>
      </div>
    </div>

    <div v-if="digest" class="mt-4 pt-4 border-t border-gray-100">
      <div class="tw-flex items-center justify-between text-sm mb-1">
        <span class="text-gray-600">Weekly digest subscribers</span>
        <span class="text-gray-400">{{ digest.subscribed }} / {{ digest.total }} ({{ digest.rate }}%)</span>
      </div>
      <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
        <div class="h-full rounded-full bg-primary" :style="{ width: digest.rate + '%' }"></div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HeartbeatInvitations',
    props: {
      users: Object,
    },
    computed: {
      invitations () {
        return (this.users && this.users.invitations) || { sent: 0, accepted: 0, acceptance_rate: 0, avg_days_to_accept: null }
      },
      digest () {
        return this.users && this.users.digest
      },
    },
  }
</script>
